
import React from "react";
import { List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import ArticleIcon from "@mui/icons-material/Article";
import HikingIcon from "@mui/icons-material/Hiking";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";
import styles from "../styles/Sidebar.module.css";

interface SidebarProps {
  isCollapsed: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ isCollapsed }) => {
  return (
    <div className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ""}`}>
      {/* Sidebar Header: Logo */}
      <div className={styles.header}>
        <img
          src={`${process.env.PUBLIC_URL}/VV_logo.png`}
          alt="Logo"
          className={styles.logo}
        />
      </div>

      <List>
        <ListItem component={Link} to="/users" className={styles.menuItem}>
          <ListItemIcon className={styles.menuIcon}>
            <PeopleIcon />
          </ListItemIcon>
          {!isCollapsed && (
            <ListItemText primary="Users" className={styles.menuText} />
          )}
        </ListItem>
        <ListItem component={Link} to="/trips" className={styles.menuItem}>
          <ListItemIcon className={styles.menuIcon}>
            <HikingIcon />
          </ListItemIcon>
          {!isCollapsed && (
            <ListItemText primary="Trips" className={styles.menuText} />
          )}
        </ListItem>
        <ListItem component={Link} to="/blogs" className={styles.menuItem}>
          <ListItemIcon className={styles.menuIcon}>
            <ArticleIcon />
          </ListItemIcon>
          {!isCollapsed && (
            <ListItemText primary="Blogs" className={styles.menuText} />
          )}
        </ListItem>
        <ListItem component={Link} to="/commercials" className={styles.menuItem}>
          <ListItemIcon className={styles.menuIcon}>
            <AdsClickIcon />
          </ListItemIcon>
          {!isCollapsed && (
            <ListItemText primary="Commercials" className={styles.menuText} />
          )}
        </ListItem>
        
        <ListItem component={Link} to="/settings" className={styles.menuItem}>
          <ListItemIcon className={styles.menuIcon}>
            <SettingsIcon />
          </ListItemIcon>
          {!isCollapsed && (
            <ListItemText primary="Settings" className={styles.menuText} />
          )}
        </ListItem>
      </List>
    </div>
  );
};

export default Sidebar;




// import React from "react";
// import { List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
// import PeopleIcon from "@mui/icons-material/People";
// import ArticleIcon from "@mui/icons-material/Article";
// import HikingIcon from "@mui/icons-material/Hiking";
// import AdsClickIcon from "@mui/icons-material/AdsClick";
// import SettingsIcon from "@mui/icons-material/Settings";
// import { Link } from "react-router-dom";
// import styles from "../styles/Sidebar.module.css";

// interface SidebarProps {
//   isCollapsed: boolean;
// }

// const Sidebar: React.FC<SidebarProps> = ({ isCollapsed }) => {
//   return (
//     <div className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ""}`}>
//       {/* Sidebar Header: Logo */}
//       <div className={styles.header}>
//         <img
//           src={`${process.env.PUBLIC_URL}/VV_logo.png`}
//           alt="Logo"
//           className={styles.logo}
//         />
//       </div>

//       <List>
//         <ListItem button component={Link} to="/users">
//           <ListItemIcon className={styles.menuIcon}>
//             <PeopleIcon />
//           </ListItemIcon>
//           {!isCollapsed && (
//             <ListItemText primary="Users" className={styles.menuText} />
//           )}
//         </ListItem>
//         <ListItem button component={Link} to="/trips">
//           <ListItemIcon className={styles.menuIcon}>
//             <HikingIcon />
//           </ListItemIcon>
//           {!isCollapsed && (
//             <ListItemText primary="Trips" className={styles.menuText} />
//           )}
//         </ListItem>
//         <ListItem button component={Link} to="/blogs">
//           <ListItemIcon className={styles.menuIcon}>
//             <ArticleIcon />
//           </ListItemIcon>
//           {!isCollapsed && (
//             <ListItemText primary="Blogs" className={styles.menuText} />
//           )}
//         </ListItem>
//         <ListItem button component={Link}>
//           <ListItemIcon className={styles.menuIcon}>
//             <AdsClickIcon />
//           </ListItemIcon>
//           {!isCollapsed && (
//             <ListItemText primary="Commercials" className={styles.menuText} />
//           )}
//         </ListItem>
//         <ListItem button component={Link}>
//           <ListItemIcon className={styles.menuIcon}>
//             <SettingsIcon />
//           </ListItemIcon>
//           {!isCollapsed && (
//             <ListItemText primary="Settings" className={styles.menuText} />
//           )}
//         </ListItem>
//       </List>
//     </div>
//   );
// };

// export default Sidebar;



